import {
  Exercise,
  Lecture,
  NoTimeExercise,
  PianoScene,
  Section,
  StaffExercise,
  Tutorial,
} from 'Utils/TutorialConfigHelper';
import { AddEventsAndMergeTimestamps, Timestamps } from 'Utils/ChaptersToTimestamps';
import timestamps from './level16.json';

const Level16 = Tutorial(16, '2:22', [
  Section([
    Lecture('A in the Treble Clef', '0:0'),
    Lecture('A on the Keyboard', '0:10'),
    Exercise(
      'Find A',
      '0:24',
      PianoScene({
        objectives: [
          {
            target: 'A4',
            text: 'Play A on your keyboard',
          },
        ],
      }),
      [],
    ),
  ]),
  Section([
    Lecture('Shifting to D Position', '0:31'),
    Exercise(
      'D Position',
      '1:25',
      NoTimeExercise({
        centre_align_horizontal: true,
        objectives: [
          { formatConfig: { first_note_offset: 50 } },
          { formatConfig: { first_note_offset: 50 } },
        ],
      }),
      [],
    ),
    Exercise(
      'Playing in Time',
      '1:41',
      StaffExercise({ objectives: [{ tempo: 72 }, { tempo: 72 }] }),
      [],
    ),
  ]),
  Section([
    Lecture('Using Both Hands', '1:52'),
    Exercise(
      'Alternating Hands',
      '2:00',
      StaffExercise({ objectives: [{ tempo: 72 }, { tempo: 72 }] }),
      [],
    ),
    Exercise(
      'Hands Together',
      '2:11.5',
      StaffExercise({ objectives: [{ tempo: 72 }, { tempo: 72 }] }),
      [],
    ),
  ]),
]);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level16);
